<template>
<div>
  <v-dialog @click:outside="close" v-model="dialog" width="850" persistent>
    <v-card outlined class="v-card-outline-primary" elevation="3">
      <v-card-title>
        <h5 class="primary--text">{{ $t("common.details") }}</h5>
        <v-spacer />
        <v-btn icon @click="close">
          <v-icon>$close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row v-for="(item, index) in points" :key="index">
          <v-col cols="10">
            <v-row>
              <v-col cols="12">
                <v-row>
                  <v-col cols="6">
                    <label for="load">{{
                        $t("fleet.roads.pointTitle")
                      }}</label>
                    <LocationInput @removeItem="deletePoint(item)" v-model="item.location" validation hideRange disabled />
                  </v-col>
                  <v-col cols="3">
                    <DatePicker disabled v-model="item.dateTime" :label="$t('fleet.roads.dateTitle')" />
                  </v-col>
                  <v-col cols="3">
                    <div class="d-flex justify-center">
                      <v-radio-group disabled v-model="item.type" row hide-details class="mt-0 pt-3">
                        <v-radio :label="$t('vehicle.load')" :value="0" />
                        <v-radio :label="$t('vehicle.unload')" :value="1" />
                      </v-radio-group>
                    </div>
                  </v-col>
                </v-row>

                <!-- Dodatkowe szczegóły -->
                <v-row v-if="hasAdditionalDetails(item)">
                  <v-col cols="12" v-if="item.description">
                    <label class="text-caption grey--text">{{ $t('fleet.roads.description') }}</label>
                    <div class="description-content pa-2 grey lighten-4 rounded" v-html="item.description"></div>
                  </v-col>

                  <v-col cols="6" v-if="item.timeFrom || item.timeTo">
                    <v-row>
                      <v-col cols="6" v-if="item.timeFrom">
                        <label class="text-caption grey--text">{{ $t('fleet.roads.timeFrom') }}</label>
                        <div class="font-weight-medium">{{ formatTimeSpan(item.timeFrom) }}</div>
                      </v-col>
                      <v-col cols="6" v-if="item.timeTo">
                        <label class="text-caption grey--text">{{ $t('fleet.roads.timeTo') }}</label>
                        <div class="font-weight-medium">{{ formatTimeSpan(item.timeTo) }}</div>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="6" v-if="item.fix !== null && item.fix !== undefined">
                    <label class="text-caption grey--text">{{ $t('fleet.roads.fix') }}</label>
                    <div class="font-weight-medium">{{ item.fix ? $t('common.yes') : $t('common.no') }}</div>
                  </v-col>

                  <v-col cols="6" v-if="item.weight !== null && item.weight !== undefined">
                    <label class="text-caption grey--text">{{ $t('fleet.roads.weight') }}</label>
                    <div class="font-weight-medium">{{ item.weight }}</div>
                  </v-col>

                  <v-col cols="6" v-if="item.loadMeters !== null && item.loadMeters !== undefined">
                    <label class="text-caption grey--text">{{ $t('fleet.roads.loadMeters') }}</label>
                    <div class="font-weight-medium">{{ item.loadMeters }}</div>
                  </v-col>
                </v-row>
                <v-divider class="my-2" />
              </v-col>
            </v-row>
          </v-col>
          <v-col>
            <div v-if="item.orderId != null" class="d-flex align-center pointer button-top" @click="openDetails(item)">
              <v-icon size="35" color="primary" class="mr-3">$infoBox</v-icon>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
  <OfferDetailsDialog v-if="offerId" :value="offerDetailsActive" :itemId="offerId" :isVehicle="false" @closed="closeOfferDetailsDialog" />
</div>
</template>

<script>
import Service from '@/services'
import DatePicker from '@/components/forms/DatePicker'
import LocationInput from '@/components/forms/LocationInput'
import OfferDetailsDialog from '@/views/Market/dialogs/OfferDetailsDialog.vue'

export default {
  components: {
    LocationInput,
    DatePicker,
    OfferDetailsDialog
  },
  data () {
    return {
      offerDetailsActive: false,
      offerId: null,
      points: [],
      dialog: false
    }
  },
  methods: {
    async open (id) {
      this.dialog = true
      const {
        data
      } = await Service.get('road/GetDetails', {
        RoadId: id
      })
      this.points = data.places
    },
    close () {
      this.points = null
      this.dialog = false
    },
    openDetails (item) {
      this.$store.commit('market/MARK_SHOW_OFFER', item)
      this.dialog = false
      this.offerId = item.orderId
      this.offerDetailsActive = true
    },
    closeOfferDetailsDialog () {
      this.offerDetailsActive = false
      this.offerId = null
      this.dialog = true
    },
    formatTimeSpan (timeSpan) {
      if (!timeSpan) return ''
      // TimeSpan format: "HH:MM:SS"
      const parts = timeSpan.split(':')
      if (parts.length >= 2) {
        return `${parts[0]}:${parts[1]}`
      }
      return timeSpan
    },
    hasAdditionalDetails (item) {
      return !!(item.description ||
                item.timeFrom ||
                item.timeTo ||
                (item.fix !== null && item.fix !== undefined) ||
                (item.weight !== null && item.weight !== undefined) ||
                (item.loadMeters !== null && item.loadMeters !== undefined))
    }
  }
}
</script>

<style scoped>
.button-top {
  padding-top: 10px
}

.description-content {
  min-height: 40px;
  word-wrap: break-word;
}

.description-content >>> p {
  margin-bottom: 8px;
}

.description-content >>> p:last-child {
  margin-bottom: 0;
}
</style>
